export const friendlyUsername = (username: string, maxChars: number) => {
    let friendlyName = username;
    if (username.length > maxChars) {
        friendlyName = `${username.slice(0, 13)}...`;
    }
    return friendlyName;
};
